import { render, staticRenderFns } from "./DisplayErrorNoPadding.vue?vue&type=template&id=b1981f58&"
import script from "./DisplayErrorNoPadding.vue?vue&type=script&lang=js&"
export * from "./DisplayErrorNoPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports